import React from 'react';
import IconBank from '@static/images/bank.svg';
import { UIGameCard } from '../../../common/UIGameCard/index.ts';
import { T, Tooltip } from '@colonist/ui';
import styles from './UIGameTradeCreatorBankRatio.module.scss';
import clsx from 'clsx';
import { usePlayerValidators } from '../../../store/selectors/usePlayerValidators.ts';
import { useGameStore } from '../../../store/GameStoreContext.ts';
import { ModeSettingEnum } from '@colonist/game-base-types';
import { passThroughTranslation } from '@colonist/i18n';
import { useCurrentStateValidator } from '../../../store/selectors/useCurrentStateValidator.ts';
import { CardDataController } from '@colonist/game-card-types';
export const UIGameTradeCreatorBankRatio = ({ className, isPortraitLayout })=>{
    var _tradeError_payload;
    const { getPlayerValidator } = usePlayerValidators();
    const isBankTradeMode = useGameStore((state)=>state.gameTrade.isBankTradeMode);
    const setIsBankTradeMode = useGameStore((state)=>state.gameTrade.setIsBankTradeMode);
    const tradeError = useGameStore((state)=>state.gameTrade.tradeError);
    const myColor = useGameStore((state)=>state.myColor);
    const currentStateValidator = useCurrentStateValidator();
    const isNotMyTurn = !currentStateValidator.currentTurnPlayers.includes(myColor);
    const myPlayerValidator = getPlayerValidator(myColor);
    const myBankTradeRatioState = myPlayerValidator.bankTradeRatiosState;
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isBeginnerMode = modeSetting === ModeSettingEnum.BeginnerModeClassic4P;
    if (isNotMyTurn || isBeginnerMode) return null;
    const tooltipContent = /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.ratioTooltipMenu, {
            [styles.portraitLayout]: isPortraitLayout
        })
    }, Object.entries(myBankTradeRatioState).sort(([firstCard], [secondCard])=>CardDataController.compareCardDisplayOrder(Number(firstCard), Number(secondCard))).map(([key, value])=>/*#__PURE__*/ React.createElement("div", {
            key: key,
            className: styles.ratioItem
        }, /*#__PURE__*/ React.createElement(UIGameCard, {
            cardEnum: Number(key),
            size: "xxxs"
        }), /*#__PURE__*/ React.createElement("div", {
            className: styles.ratioValue
        }, /*#__PURE__*/ React.createElement(T, {
            id: passThroughTranslation(`${value}:1`)
        })))));
    const hasBankRatioError = tradeError === null || tradeError === void 0 ? void 0 : (_tradeError_payload = tradeError.payload) === null || _tradeError_payload === void 0 ? void 0 : _tradeError_payload.hasBankTradeRatioError;
    return /*#__PURE__*/ React.createElement(Tooltip, {
        position: isPortraitLayout ? 'top' : 'right',
        customMenuComponent: tooltipContent,
        className: clsx(styles.ratioContainer, className)
    }, /*#__PURE__*/ React.createElement("img", {
        src: IconBank,
        className: clsx(styles.ratioIcon, {
            [styles.active]: isBankTradeMode,
            [styles.shakingAnimation]: hasBankRatioError
        }),
        onClick: ()=>setIsBankTradeMode(!isBankTradeMode)
    }));
};
